export const MARKDOWN_EXTENSIONS: ReadonlySet<string> = new Set(['md', 'markdown', 'mkd', 'mdown', 'mkdn', 'mdwn']);

export const CODE_EXTENSIONS: ReadonlySet<string> = new Set([
  'js',
  'ts',
  'tsx',
  'jsx',
  'css',
  'scss',
  'less',
  'html',
  'htm',
  'xml',
  'json',
  'yaml',
  'yml',
  'py',
  'rb',
  'go',
  'rs',
  'java',
  'c',
  'h',
  'cpp',
  'cs',
  'sh',
  'bash',
  'zsh',
  'php',
  'sql',
]);
